import InfoIcon from '@mui/icons-material/Info';

import styles from './InfoHover.module.css';

export function InfoWalkmeCrumb({ elId }: { elId: string }) {
  return (
    <span id={elId} className={`info_walkme_crumb ${styles.info_walkme_crumb}`}>
      <InfoIcon />
    </span>
  );
}
